import React, { useState, useEffect, forwardRef, useCallback } from 'react';
import { Button, message, Tag, Tooltip } from 'antd';
import { CheckCircleOutlined,CloseCircleOutlined,SyncOutlined,DeleteOutlined,RollbackOutlined } from '@ant-design/icons';
import Tabler from './Tabler.jsx'
import moment from 'moment';
import { hasRight,getUser } from './Login';
import { handleException } from './Utils.jsx';
import axiosInstance from './axiosInstance';


const TableLoan  = forwardRef((props,ref) => {
	
	const writeRight = hasRight('loans','W');
	const setDone = useCallback((record) => {
		(async () => {
			try {
				const response = await axiosInstance.post('/setdone', { recid: record.loanId });
				record.done = response.data
				ref.current.updateData();
				message.success('Záznam byl nastaven');
			} catch (err) { handleException(err) };
		})();
	}, []);

	const setRemoved = useCallback((record) => {
		(async () => {
			try {
				const response = await axiosInstance.post('/setremoved', { recid: record.loanId });
				//record.removed = response.data
				//ref.current.updateData();
				ref.current.refresh();
				message.success('Záznam byl nastaven');
			} catch (err) { handleException(err) };
		})();
	}, []);
	
	function renderDone(_, r) {
		const right = (writeRight || r.lenderId === getUser().userId);
		/*
		return (
			<>
				{ r.done ? <CheckCircleOutlined style={{ color: 'green', fontSize: '16px' }} /> : <SyncOutlined style={{ color:'orange', fontSize: '16px' }} />}
				{right && <Button style={{height:'20px', maxWidth:'80px', marginLeft:'4px', color:'gray'}} onClick={() => setDone(r)}>{r.done?'Zpracování':'Dokončeno'}</Button>}
				</>
		)*/
		return (
			<Button type="text" title={r.done?'nastavit Zpracování':'nastavit Dokončeno'} style={{height:'20px', color: r.done ? 'green' : 'orange'}} icon={r.done?<CheckCircleOutlined/>:<SyncOutlined/>} onClick={() => right && setDone(r)}>
				{r.done?'Dokončeno':'Zpracování'}
			</Button>
		)
	}
	function renderRemoved(_, r) {	
		return (
			<Button type="text" title={!r.removed?'Do koše':'Obnovit'} style={{height:'20px'}} icon={!r.removed?<DeleteOutlined/>:<RollbackOutlined/>} onClick={() => setRemoved(r)}/>
		)
		
	}
	
	function renderNote(_, r) {
      return (
	  	<Tooltip title={r.note}>
			<span className="ellipsis" style={{maxWidth: 200,whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block'}}  >{r.note}</span>
		</Tooltip>
	  ) 
    }

	const lendercolumns = [
		{"dataIndex": ["assigndt"], "title": "Dat. přiřazení.", "width": 150, "options": {"type": "date", "sortable": true, "searchable": true}, render:(_, r) => r.assigndt?moment(r.assigndt).format('DD.MM.YYYY HH:mm'):''},
		{"dataIndex": ['lender','name'], "title": "Půjčující", "width": 100, "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["name"], "title": "Jméno", "width": 150, "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["note"], "title": "Poznámky", "width": 200, "options": {"type": "text", "sortable": true, "searchable": true}, render:renderNote},
		{"dataIndex": ["pin"], "title": "Rodné číslo", "width": 150, "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["mail"], "title": "E-mail", "width": 200, "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["phone"], "title": "Telefon", "width": 150, "options": {"type": "text", "sortable": true, "searchable": true}},		
		{"dataIndex": ["income"], "title": "Příjem", "width": 100, "options": {"type": "number", "sortable": true, "searchable": true}},
		{"dataIndex": ["housingType"], "title": "Typ bydlení", "width": 200, "options": {"type": "text", "sortable": true, "searchable": true}},
		{"dataIndex": ["insolvency_execution"], "title": "Insolvence/Exekuce", "width": 200, "options": {"type": "text", "sortable": true, "searchable": true}},
	]

	const columns = [		
		{"dataIndex": ["loanId"], "title": "ID", "width": 80, "options": {"type": "number", "sortable": true, "searchable": true}},
		{"dataIndex": ["region"], "title": "Kraj", "width": 200, "options": {"type": "text", "sortable": true, "searchable": true}},
		...(props?.lender ? lendercolumns:[]),
		{"dataIndex": ["credt"], "title": "Dat. vytv.", "width": 130, "options": {"type": "date", "sortable": true, "searchable": true}, render:(_, r) => moment(r.credt).format('DD.MM.YYYY')},
		{"dataIndex": ["creby", "name"], "title": "Vytvořil", "width": 100, "options": {"type": "text", "sortable": true, "searchable": true}},  	
		{"dataIndex": ["moddt"], "title": "Dat. modif.", "width": 130, "options": {"type": "date", "sortable": true, "searchable": true}, render:(_, r) => moment(r.moddt).format('DD.MM.YYYY')},
		{"dataIndex": ["modby", "name"], "title": "Modif.", "width": 100, "options": {"type": "text", "sortable": true, "searchable": true}},  	
		{dataIndex: "last",     title: " "}
	];
	//if(props?.lender) columns.unshift({"dataIndex": ["done"], "align": 'center', "title": "Stav", "width": 125, "options": {"type": "text", "sortable": true, "searchable": false},render:renderDone});
	
	//if(writeRight) columns.unshift({"dataIndex": ["removed"], "align": 'center', "title": "Koš", "width": 60, "options": {"type": "text", "sortable": true, "searchable": false},render:renderRemoved});

	return <Tabler
		{...props} 
		columns={columns}
		tableLayout="fixed"
		entity='TLoan' 
		sortData={[{'field': "credt", "direction": "desc"}]}
		url='/dataservice'
		//rowKey={(r) => `${r.source}-${r.loanId}`}
		rowKey="recid"
		ref={ref}
	/>;
});

export default TableLoan;
